import React, { FunctionComponent, SVGProps } from 'react'

export const IconDisposalOfTheRight: FunctionComponent<
  SVGProps<SVGSVGElement>
> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 11.25C10.5533 11.25 11.8125 9.9908 11.8125 8.4375C11.8125 6.8842 10.5533 5.625 9 5.625C7.4467 5.625 6.1875 6.8842 6.1875 8.4375C6.1875 9.9908 7.4467 11.25 9 11.25Z"
      strokeWidth="1.2"
      strokeMiterlimit="10"
    />
    <path
      d="M4.48633 14.0185C4.91004 13.1854 5.55601 12.4859 6.35272 11.9973C7.14944 11.5086 8.06583 11.25 9.00045 11.25C9.93507 11.25 10.8515 11.5086 11.6482 11.9972C12.4449 12.4859 13.0909 13.1854 13.5146 14.0185"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.375 3.9375H15.75"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0625 2.25V5.625"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6665 7.93532C15.89 9.34196 15.6623 10.7832 15.0161 12.0525C14.3699 13.3218 13.3384 14.3538 12.0695 15.0007C10.8006 15.6476 9.3595 15.8761 7.95273 15.6534C6.54596 15.4308 5.24582 14.7684 4.2387 13.7613C3.23159 12.7542 2.56923 11.4541 2.34658 10.0473C2.12393 8.64052 2.35244 7.19938 2.99933 5.93049C3.64623 4.66159 4.67829 3.63011 5.94755 2.98393C7.21681 2.33775 8.65808 2.11006 10.0647 2.3335"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
